import React from "react";
import { NavBarThree } from "../components/Header";
import { FootBar } from "../components/Footer";
import { ImageProfil, UserForm } from "../components/Form";
import { useQuery } from "@tanstack/react-query";
import { UserContainer } from "../components/Container";
import { UserApi } from "../app/api/user.api";
import { ProfilStats } from "../components/Stats";


const user = UserApi();


export function Profil()
{

    const findUser = async () => {
        const {data} = await user.findCurUser();
        return data.data;
    };
         
    const { data, error, isLoading } = useQuery({
        queryKey: ["user"],
        queryFn: findUser,
    });

   
    return(

        <div className="container-fluid">
            <div className="row">          
                {/* *************************************************************** */}
                <div className="col-lg-12 sticky-top bg-light border-bottom">  <NavBarThree target={'profil'} />  </div>
                {/* ************************************************* */}
                <div className="col-md-12">  
                    <div className="row min-vh-100">  
                        {/* ---------------------------------------------------------- */}
                        <div className="col-lg-3 py-5 border-bottom bg-light">   
                            <ImageProfil data={data} />
                            <UserContainer isLoading={isLoading} error={error} data={data} />
                        </div>   
                        {/* ---------------------------------------------------------- */}
                        <UserForm  data={data} />
                        {/* --------------------------------------------------------- */}
                        <div className="col-lg-5 border-start bg-light">
                            <ProfilStats />
                        </div>

                        {/* ---------------------------------------------------------- */} 
                    </div>     
                </div> 
        
                {/* *************************************************************** */}
                <div className="col-lg-12 bg-dark">  <FootBar />  </div>
        
            </div>
        </div>  

    )
}



